/* @flow weak */
import React from 'react';

import BirthdateModalSectionMixin from 'chat/components/mixins/BirthdateModalSectionMixin.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import RoleSelector from './RoleSelector.jsx';
import UserActions from 'user/UserActions';

/**
 * The actual render is in BirthdateModalSectionMixin
 */
/* eslint-disable react/require-render-return */
const AskForRole = React.createClass({
  mixins: [BirthdateModalSectionMixin],

  getInitialState() {
    return {
      role: '',
    };
  },

  onSubmit() {
    UserActions.setRole(this.state.role);
  },

  getSubtext() {
    return <Link href={LinkConstants.CHAT_RESTRICTIONS}>Learn more</Link>;
  },

  buttonDisabled() {
    return false;
  },

  roleChanged(role) {
    this.setState({ role });
  },

  title() {
    return 'To use Chat, please let us know your role.';
  },

  renderCollector() {
    return <RoleSelector onChange={this.roleChanged} value={this.state.role} />;
  },
});

export default AskForRole;



// WEBPACK FOOTER //
// ./src/chat/components/AskForRole.jsx